import React from "react";
import { useIntl } from "react-intl";
import { Field } from "redux-form";
import { FormControl, FormGroup } from "react-bootstrap";
import { compose } from "redux";
import withStyles from "isomorphic-style-loader/withStyles";

import messages from "../../../../locale/jsonMessages";

//Style
import cs from '../../../../components/commonStyle.css'

const PayPalPayment = ({ paymentCurrencyList }) => {

    const { formatMessage } = useIntl();

    const renderPaymentCurrencies = () => {
        const rows = [
            { value: '', label: formatMessage(messages.chooseCurrency) }
        ];
        paymentCurrencyList?.forEach(item => {
            if (item?.isEnable && item?.isPayment) {
                rows.push({
                    value: item?.symbol,
                    label: item?.symbol
                });
            }
        });
        return rows;
    };

    const renderFormControlSelect = ({ input, meta: { touched, error }, children, className, disabled }) => {
        return (
            <FormGroup className={cs.spaceBottom0}>
                <FormControl disabled={disabled} componentClass="select" {...input} className={className}>
                    {children}
                </FormControl>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    };

    return (
        <Field
            name="paymentCurrency"
            type="text"
            className='commonSelectField'
            component={renderFormControlSelect}
        >
            {renderPaymentCurrencies().map((item, index) => (
                <option key={index} value={item.value}>
                    {item.label}
                </option>
            ))}
        </Field>
    );
};

export default compose(
    withStyles(cs),
)(PayPalPayment);
